<template>
  <v-card class="my-2 pa-0" outlined>
    <v-card-title
      class="py-2 font-weight-medium subtitle-2"
      :class="
        $vuetify.theme.isDark
          ? 'grey darken-3 white--text'
          : 'grey lighten-4 black--text'
      "
      @click="localShowDetails = !localShowDetails"
    >
      <v-icon left dense :color="iconColor">{{ icon }}</v-icon
      >{{ title }}<v-spacer></v-spacer>

      <v-icon dense>{{
        localShowDetails ? "mdi-chevron-down" : "mdi-chevron-right"
      }}</v-icon>
    </v-card-title>
    <v-expand-transition>
      <div v-if="localShowDetails">
        <v-divider></v-divider>

        <slot name="details"></slot>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
export default {
  name: "tipp-card",
  props: {
    title: {
      type: String,
      default: "Hinweis",
    },
    text: {
      type: String,
      default: "",
    },
    btnText: {
      type: String,
      default: "Verstanden",
    },
    icon: {
      type: String,
    },
    iconColor: {
      type: String,
      default: "primary",
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    showDetails: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      internalShowDetails: this.showDetails,
    };
  },
  watch: {
    showDetails(val) {
      this.internalShowDetails = val;
    },
  },
  computed: {
    localShowDetails: {
      get() {
        // Use prop if parent controls it, otherwise use internal state
        return Object.prototype.hasOwnProperty.call(
          this.$options.propsData,
          "showDetails",
        )
          ? this.showDetails
          : this.internalShowDetails;
      },
      set(value) {
        if (
          Object.prototype.hasOwnProperty.call(
            this.$options.propsData,
            "showDetails",
          )
        ) {
          this.$emit("update:showDetails", value);
        } else {
          this.internalShowDetails = value;
        }
      },
    },
  },
};
</script>
